<form class="report-details-form" [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <app-dropdown-autocomplete
        class="adhesive"
        valueField="id"
        displayField="name"
        label="{{'admin.strain.tickets.reports.modal.step4.adhesive' | translate}}"
        emptyText="{{'admin.strain.tickets.reports.modal.step4.adhesive' | translate}}"
        [formControl]="control('adhesive')"
        [items]="adhesives"
        [showErrors]="showValidations || control('adhesive').touched && control('adhesive').invalid">
    </app-dropdown-autocomplete>

    <app-dropdown-autocomplete
        class="mounted-by"
        valueField="id"
        displayField="name"
        label="{{'admin.strain.tickets.reports.modal.step4.mountedBy' | translate}}"
        emptyText="{{'admin.strain.tickets.reports.modal.step4.mountedBy' | translate}}"
        [formControl]="control('mountedBy')"
        [items]="users"
        [showErrors]="showValidations || control('mountedBy').touched && control('mountedBy').invalid">
    </app-dropdown-autocomplete>

    <app-input-datepicker class="mounting-date"
                          [formControl]="control('mountingDate')"
                          label="{{'admin.strain.tickets.reports.modal.step4.mountingDate' | translate}}"
                          placeholder="{{'admin.strain.tickets.reports.modal.step4.mountingDate' | translate}}"
                          inputDateFormat="timestamp"
                          [showErrors]="showValidations">
    </app-input-datepicker>

    <app-input
        class="evaluated-by"
        [formControl]="control('evaluatedBy')"
        [showErrors]="showValidations || control('evaluatedBy').touched && control('evaluatedBy').invalid"
        label="{{'admin.strain.tickets.reports.modal.step4.evaluatedBy' | translate}}"
        [placeholder]="'admin.strain.tickets.reports.modal.step4.evaluatedBy' | translate">
    </app-input>

    <app-input-datepicker class="evaluation-date"
                          [formControl]="control('evaluationDate')"
                          label="{{'admin.strain.tickets.reports.modal.step4.evaluationDate' | translate}}"
                          placeholder="{{'admin.strain.tickets.reports.modal.step4.evaluationDate' | translate}}"
                          [showErrors]="showValidations"
                          inputDateFormat="timestamp">
    </app-input-datepicker>


</form>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
